import React from 'react';
import { isMobile } from 'react-device-detect'
import { useHistory } from 'react-router-dom';

import { Button } from 'components'
import OvercomeAnimate from 'resources/overcome-animate.svg'

import classes from './CallToAction.module.css'

const CallToAction = props => {
    const {} = props;
    let history = useHistory()

    return (
        <div className={classes.ActionSection}>
            <div className={classes.GlassWrapper}>
                <div className={classes.ActionText}>Ready to get things</div>
                <div style={{display: 'grid', gridColumnGap: '0.5rem', gridTemplateColumns: 'auto auto', marginBottom: '0.5rem'}}>
                    <div className={classes.ActionTitle}>Atomicly</div>
                    <div className={classes.ActionText}>done?</div>
                </div>
                <Button text="Try for free" styles={{backgroundColor: '#957fef', fontSize: '1rem', padding: isMobile ? '0.5rem' : '0.75rem', margin: 0, width: '10rem'}} onSelect={() => history.push('/register')}/>
            </div>
            <img className={classes.BannerImg} src={OvercomeAnimate}/> 
        </div>
    )
}

export default CallToAction;